import { useCallback } from 'react';

export const useBindProductField = (onUpdateField) => useCallback(
  (field) => (value) => onUpdateField(field, value),
  [onUpdateField],
);
